import { render, staticRenderFns } from "./CurrentRights.vue?vue&type=template&id=845e7a5a&scoped=true"
import script from "./CurrentRights.vue?vue&type=script&lang=js"
export * from "./CurrentRights.vue?vue&type=script&lang=js"
import style0 from "./CurrentRights.vue?vue&type=style&index=0&id=845e7a5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845e7a5a",
  null
  
)

export default component.exports